import { lazy } from 'react';
import PageView from './PageView';

const BundlePage = lazy(() => import('src/pages/bundle'));

export const bundleRoutes = [
  {
    path: 'bundle',
    element: <PageView permission="BO_CAN_VIEW_BUNDLES" />,
    children: [{ element: <BundlePage />, index: true }],
  },
];
